import { BottomSheet } from '@s4l/ds'
import classNames from 'classnames'
import React, { useRef } from 'react'
import { useIntl } from 'react-intl'
import { useIntersection } from 'react-use'
import { getPaxes } from 'src/comps/Molecules/Paxes/helpers'
import MobilePill from 'src/comps/Molecules/Suggester/MobilePill'
import SearchButton from 'src/comps/SearchButton'
import { isProperty } from 'src/context/search/utils'
import { useSearch } from 'src/hooks/useSearch'
import { SearchMode, SearchUrl } from 'src/types/search'
import { DatePicker } from '../DatePicker'
import { OmniSearch } from '../Omnisearch'
import { Paxes } from '../Paxes'
import { Suggester } from '../Suggester'
import styles from './styles.module.css'

interface IOmniSearchMobileProps {
  readonly searchUrl: SearchUrl
  readonly onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
}

export function OmnisearchMobile({ searchUrl, onClick }: IOmniSearchMobileProps) {
  const mobileSuggesterRef = useRef<HTMLDivElement>(null)
  const intl = useIntl()
  const { draftRooms, draftCheckin, draftCheckout, draftLocation } = useSearch()

  const paxesPlain = getPaxes(draftRooms)

  const suggestionText = isProperty(draftLocation?.Type)
    ? draftLocation?.Text
    : draftLocation?.Description

  const mobileIntersection = useIntersection(mobileSuggesterRef, {
    root: null,
    rootMargin: '0px',
    threshold: 0.15,
  })

  return (
    <>
      <div className={styles.searchMobile}>
        <Suggester />
        <DatePicker />
        <Paxes />
        <SearchButton searchUrl={searchUrl} onClick={onClick} fullWidth preventNavigation={false} />
      </div>

      <div ref={mobileSuggesterRef} />

      <div
        className={classNames(styles.mobileBottomSheet, {
          [styles.appear]: mobileIntersection && mobileIntersection.intersectionRatio <= 0,
        })}
      >
        <BottomSheet snapPoints={[]}>
          <MobilePill
            text={suggestionText}
            checkIn={draftCheckin}
            checkOut={draftCheckout}
            paxes={paxesPlain}
          />

          <BottomSheet.Content title={intl.formatMessage({ id: 'modify.search' })}>
            <OmniSearch mode={SearchMode.Full} />
          </BottomSheet.Content>
        </BottomSheet>
      </div>
    </>
  )
}
